import { formatUnixToTimeWithHourPrefixValue } from '../../../../shared/utils/dateTime/dateTimeUtils';
import TimeSyncedWithActStartTime from '../../../components/Form/ActSpecificField/TimeSyncedWithActStartTime/TimeSyncedWithActStartTime';

const DIFFERENT_SESSION_END_TIME = 'differentSessionEndTime';

const summaryRender = (code) =>
  code[DIFFERENT_SESSION_END_TIME]
    ? [
        {
          name: 'heure fin',
          value: formatUnixToTimeWithHourPrefixValue(code[DIFFERENT_SESSION_END_TIME])
        }
      ]
    : [];

const associatedFields = [
  {
    label: 'Heure fin',
    getName: (index) => `codes[${index}].${DIFFERENT_SESSION_END_TIME}`,
    type: TimeSyncedWithActStartTime
  }
];

export default { associatedFields, summaryRender };
